// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Card Container Layout */
.search-terms-container {
  display: flex;
  overflow-x: auto;
  gap: 1.5rem;
 
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  max-height: 794px;
}

.search-terms-container::-webkit-scrollbar {
  height: 8px;
}

.search-terms-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.search-terms-container::-webkit-scrollbar-thumb {
  background: #65CCB7;
  border-radius: 10px;
}

.search-terms-container::-webkit-scrollbar-thumb:hover {
  background: #52b2a1;
}

.search-term-section {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% - 2rem);
  scroll-snap-align: start;
  white-space: normal;
}

.card-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin: 1rem;
  padding: 0.5rem;
}

.card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  width: 100%;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Card Header */
.OT-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  color: white;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.OT-card-header span {
  font-size: 1.1rem;
}

.sort-controls {
  display: flex;
  gap: 0.75rem;
}

.sort-controls div {
  cursor: pointer;
  padding: 0.25rem;
  transition: transform 0.2s ease;
}

.sort-controls div:hover {
  transform: scale(1.15);
}

/* Card Content */
.OT-card-content {
  max-height: calc(100vh - 250px);
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 1rem;
  scrollbar-width: thin;
}

.OT-card-content::-webkit-scrollbar {
  width: 6px;
}

.OT-card-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.OT-card-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.OT-card-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Post Cards */
.OT-post-card {
  background: white;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  padding: 1.25rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.2s ease;
}

.OT-post-card:hover {
  transform: translateY(-2px);
}

.color-strip {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

/* Platform-specific colors */
.card[data-platform="twitter"] .color-strip {
  background: #1DA1F2;
}

.card[data-platform="facebook"] .color-strip {
  background: #3b5998;
}

.card[data-platform="instagram"] .color-strip {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
}

.card[data-platform="tiktok"] .color-strip {
  background: linear-gradient(45deg, #69C9D0, #EE1D52);
}

/* Post Header */
.OT-post-card .header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.username a {
  color: #1DA1F2;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.username a:hover {
  color: #0c85d0;
}

.name {
  color: #4a5568;
  font-size: 0.9rem;
}

.date-time {
  color: #718096;
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

/* Post Content */
.OT-Card-content {
  margin: 1rem 0;
}

.post-text {
  color: #2d3748;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.post-text p {
  margin: 0;
}

.highlighted-term {
  background-color: #fef3c7;
  padding: 0.125rem 0.25rem;
  border-radius: 3px;
  transition: background-color 0.2s ease;
}

.highlighted-term:hover {
  background-color: #fde68a;
}

/* Post Stats */
.OT-Card-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 10px 10px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #64748b;
  font-size: 0.9rem;
  transition: color 0.2s ease;
}

.stat-item:hover {
  color: #0ea5e9;
}

/* Originator Badge */
.originator-text {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #dc2626;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);
  z-index: 10;
}

.originator-number {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.125rem 0.375rem;
  border-radius: 9999px;
}

/* Open Post Button */
.open-post-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0.5rem;
  border-radius: 9999px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.open-post-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

/* Search Term Section */
.search-term-section {
  margin-bottom: 2rem;
}

.search-term-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0 1rem;
}

.search-term-title {
  font-size: 1.5rem;
  color: #1a202c;
  font-weight: 600;
}

.remove-search-term {
  background: none;
  border: none;
  color: #ef4444;
  padding: 0.5rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.remove-search-term:hover {
  color: #dc2626;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .card-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .card-container {
    grid-template-columns: 1fr;
  }

  .OT-card-content {
    max-height: 60vh;
  }

  .OT-Card-stats {
    flex-direction: column;
    gap: 0.75rem;
  }

  .stat-item {
    justify-content: center;
  }

  .search-terms-container {
    gap: 1rem;
  }

  .search-term-section {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 1rem);
  }
}

@media (max-width: 480px) {
  .card-container {
    margin: 0.5rem;
  }

  .OT-post-card {
    padding: 1rem;
  }

  .search-term-title {
    font-size: 1.25rem;
  }

  .search-terms-container {
    padding: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/origin tracker/OTCardContainer.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;;EAEX,6BAA6B;EAC7B,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAA2B;EAA3B,cAA2B;EAA3B,6BAA2B;EAC3B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;EACrD,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,oDAAoD;AACtD;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Card Container Layout */\r\n.search-terms-container {\r\n  display: flex;\r\n  overflow-x: auto;\r\n  gap: 1.5rem;\r\n \r\n  scroll-snap-type: x mandatory;\r\n  -webkit-overflow-scrolling: touch;\r\n  white-space: nowrap;\r\n  max-height: 794px;\r\n}\r\n\r\n.search-terms-container::-webkit-scrollbar {\r\n  height: 8px;\r\n}\r\n\r\n.search-terms-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.search-terms-container::-webkit-scrollbar-thumb {\r\n  background: #65CCB7;\r\n  border-radius: 10px;\r\n}\r\n\r\n.search-terms-container::-webkit-scrollbar-thumb:hover {\r\n  background: #52b2a1;\r\n}\r\n\r\n.search-term-section {\r\n  flex: 0 0 calc(100% - 2rem);\r\n  scroll-snap-align: start;\r\n  white-space: normal;\r\n}\r\n\r\n.card-container {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 1.5rem;\r\n  margin: 1rem;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.card {\r\n  background-color: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n  overflow: hidden;\r\n  width: 100%;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Card Header */\r\n.OT-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem 1.5rem;\r\n  color: white;\r\n  font-weight: 600;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.OT-card-header span {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.sort-controls {\r\n  display: flex;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.sort-controls div {\r\n  cursor: pointer;\r\n  padding: 0.25rem;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.sort-controls div:hover {\r\n  transform: scale(1.15);\r\n}\r\n\r\n/* Card Content */\r\n.OT-card-content {\r\n  max-height: calc(100vh - 250px);\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  padding: 1rem;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.OT-card-content::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.OT-card-content::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 10px;\r\n}\r\n\r\n.OT-card-content::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 10px;\r\n}\r\n\r\n.OT-card-content::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n/* Post Cards */\r\n.OT-post-card {\r\n  background: white;\r\n  border-radius: 10px;\r\n  margin-bottom: 1.5rem;\r\n  padding: 1.25rem;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  position: relative;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.OT-post-card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.color-strip {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 4px;\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n}\r\n\r\n/* Platform-specific colors */\r\n.card[data-platform=\"twitter\"] .color-strip {\r\n  background: #1DA1F2;\r\n}\r\n\r\n.card[data-platform=\"facebook\"] .color-strip {\r\n  background: #3b5998;\r\n}\r\n\r\n.card[data-platform=\"instagram\"] .color-strip {\r\n  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);\r\n}\r\n\r\n.card[data-platform=\"tiktok\"] .color-strip {\r\n  background: linear-gradient(45deg, #69C9D0, #EE1D52);\r\n}\r\n\r\n/* Post Header */\r\n.OT-post-card .header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.username a {\r\n  color: #1DA1F2;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.username a:hover {\r\n  color: #0c85d0;\r\n}\r\n\r\n.name {\r\n  color: #4a5568;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.date-time {\r\n  color: #718096;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Post Content */\r\n.OT-Card-content {\r\n  margin: 1rem 0;\r\n}\r\n\r\n.post-text {\r\n  color: #2d3748;\r\n  line-height: 1.5;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.post-text p {\r\n  margin: 0;\r\n}\r\n\r\n.highlighted-term {\r\n  background-color: #fef3c7;\r\n  padding: 0.125rem 0.25rem;\r\n  border-radius: 3px;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.highlighted-term:hover {\r\n  background-color: #fde68a;\r\n}\r\n\r\n/* Post Stats */\r\n.OT-Card-stats {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n  padding: 1rem;\r\n  background: #f8fafc;\r\n  border-top: 1px solid #e2e8f0;\r\n  border-radius: 0 0 10px 10px;\r\n}\r\n\r\n.stat-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  color: #64748b;\r\n  font-size: 0.9rem;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.stat-item:hover {\r\n  color: #0ea5e9;\r\n}\r\n\r\n/* Originator Badge */\r\n.originator-text {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1rem;\r\n  background: #dc2626;\r\n  color: white;\r\n  padding: 0.25rem 0.75rem;\r\n  border-radius: 9999px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.3);\r\n  z-index: 10;\r\n}\r\n\r\n.originator-number {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  padding: 0.125rem 0.375rem;\r\n  border-radius: 9999px;\r\n}\r\n\r\n/* Open Post Button */\r\n.open-post-button {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1rem;\r\n  padding: 0.5rem;\r\n  border-radius: 9999px;\r\n  background: white;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.open-post-button:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Search Term Section */\r\n.search-term-section {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.search-term-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1rem;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.search-term-title {\r\n  font-size: 1.5rem;\r\n  color: #1a202c;\r\n  font-weight: 600;\r\n}\r\n\r\n.remove-search-term {\r\n  background: none;\r\n  border: none;\r\n  color: #ef4444;\r\n  padding: 0.5rem;\r\n  cursor: pointer;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.remove-search-term:hover {\r\n  color: #dc2626;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1400px) {\r\n  .card-container {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .card-container {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .OT-card-content {\r\n    max-height: 60vh;\r\n  }\r\n\r\n  .OT-Card-stats {\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .stat-item {\r\n    justify-content: center;\r\n  }\r\n\r\n  .search-terms-container {\r\n    gap: 1rem;\r\n  }\r\n\r\n  .search-term-section {\r\n    flex: 0 0 calc(100% - 1rem);\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .card-container {\r\n    margin: 0.5rem;\r\n  }\r\n\r\n  .OT-post-card {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .search-term-title {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .search-terms-container {\r\n    padding: 0.5rem;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
